import { IServiceItem } from "app/services/specification"
import { MetaTypeEnum } from "../enums"

export const specificationOrderKeys =
    ["sayfa", "baskiSayisi", "ilkBaskiTarihi", "sonBaskiTarihi", "crmStok", "son14GunSiparisAdeti", "baskiDurumu", "cokSatan", "satisDurumu", "yeniEski", "pdf", "ses", "diziler", "kitaplik", "seri", "tip", "setTipi", "promosyonTip", "materyalTip", "dil", "orjinalDilName", "hedefKitle", "markalar"]

export const customSpecificationServices: IServiceItem[] = [
    {
        name: "brand",
        title: "Markalar"
    },
    {
        name: "category",
        title: "Kategoriler"
    },
    {
        name: "contributor",
        title: "Eser Katılımcıları"
    },
    {
        name: "contributorRole",
        title: "Eser Katılımcısı Rolleri"
    }
]

export const specificationKeys = [{
    key: "tur",
    type: MetaTypeEnum.Dropdown
}, {
    key: "blogCategory",
    type: MetaTypeEnum.Dropdown
}, {
    key: "blogStartDate",
    type: MetaTypeEnum.Date
}, {
    key: "blogEndDate",
    type: MetaTypeEnum.Date
}, {
    key: "blogFullName",
    type: MetaTypeEnum.Dropdown
}, {
    key: "eventHighlighted",
    type: MetaTypeEnum.Checkbox
}, {
    key: "eventCanceled",
    type: MetaTypeEnum.Checkbox
}, {
    key: "digitalCurtainCategory",
    type: MetaTypeEnum.Dropdown
}, {
    key: "eventType",
    type: MetaTypeEnum.Dropdown
}, {
    key: "eventVenue",
    type: MetaTypeEnum.Dropdown
}, {
    key: "eventStartDate",
    type: MetaTypeEnum.Date
}, {
    key: "eventEndDate",
    type: MetaTypeEnum.Date
}, {
    key: "musicPlatformType",
    type: MetaTypeEnum.Dropdown
}]
